import { render, staticRenderFns } from "./PlayerStatsTable.vue?vue&type=template&id=0c6dabdb&lang=pug"
import script from "./PlayerStatsTable.vue?vue&type=script&lang=js"
export * from "./PlayerStatsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports